import React, { Component } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

const guideMessages = {
  BASIC: [
    {
      id: 'Guide.howToUse.definition.BASIC.desc.1',
      defaultMessage: '1. You can submit a single sticker! (Each pack may contain at least 1 but fewer than 24 stickers)',
    },
    {
      id: 'Guide.howToUse.definition.BASIC.desc.2',
      defaultMessage: '2. Both animated stickers (GIF) and still image stickers (PNG) are accepted.',
    },
    {
      id: 'Guide.howToUse.definition.BASIC.desc.3',
      defaultMessage: '3. The screening period and process are the same as the plus pack.',
    },
    {
      id: 'Guide.howToUse.definition.BASIC.desc.4',
      defaultMessage: '4. Once submitted, the pack type cannot be changed.',
    },
  ],
  PLUS: [
    {
      id: 'Guide.howToUse.definition.PLUS.desc.1',
      defaultMessage: '1. You can submit a single sticker! (Each pack may contain at least 1 but fewer than 24 stickers)',
    },
    {
      id: 'Guide.howToUse.definition.PLUS.desc.2',
      defaultMessage: '2. Both animated stickers (GIF) and still image stickers (PNG) are accepted.',
    },
    {
      id: 'Guide.howToUse.definition.PLUS.desc.3',
      defaultMessage: '3. The screening period and process are the same as the plus pack.',
    },
    {
      id: 'Guide.howToUse.definition.PLUS.desc.4',
      defaultMessage: '4. Once submitted, the pack type cannot be changed.',
    },
    {
      id: 'Guide.howToUse.definition.PLUS.desc.5',
      defaultMessage: '5. Once submitted, the pack type cannot be changed.',
    },
  ],
}

class GuidePackTypeDefinition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packType: props.packType,
      description: [],
    };
  }

  componentDidMount() {
    const { packType } = this.state;

    this.setState({
      description: guideMessages[packType],
    });
  }

  render() {
    const { packType, description } = this.state;

    return (
      <div>
        <div className="guide-pack-type-definition-title">
          <FormattedMessage
            id={`Guide.howToUse.definition.${packType}`}
            defaultMessage='Basic Pack'
          />
        </div>
        <div className="guide-pack-type-definition-description">
          {
            description.map(desc => (
              <p>
                <FormattedHTMLMessage
                  id={`${desc.id}`}
                  defaultMessage={`${desc.defaultMessage}`}
                />
              </p>
            ))
          }
        </div>
      </div>
    )
  }
}

export default GuidePackTypeDefinition;